import { api } from "../../services/api";

export async function signInCustomer(credentials) {
    const payload = { user: credentials.user, password: credentials.password };

    const response = await api.post('/auth.php', payload);
    return response.data;
};

export async function getCustomerData() {
    try {
        const response = await api.get('/auth.php');
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return { error: true, type: 'token', message: 'Não autenticado.' };
        }
        throw error;
    }
};

export async function signOutCustomer() {
    try {
        await api.post('/auth.php', { action: 'logout' });
    } catch (error) {
        console.log(error);
    };
};
